import { toast as sonnerToast } from 'sonner'

/**
 * Toast notification utility
 * Wraps sonner toast with consistent styling and API
 */
export const toast = {
  /**
   * Show a success toast
   */
  success: (message: string, options?: { description?: string }) => {
    sonnerToast.success(message, {
      description: options?.description,
    })
  },

  /**
   * Show an error toast
   */
  error: (message: string, options?: { description?: string }) => {
    sonnerToast.error(message, {
      description: options?.description,
    })
  },

  /**
   * Show a warning toast
   */
  warning: (message: string, options?: { description?: string }) => {
    sonnerToast.warning(message, {
      description: options?.description,
    })
  },

  /**
   * Show an info toast
   */
  info: (message: string, options?: { description?: string }) => {
    sonnerToast.info(message, {
      description: options?.description,
    })
  },

  /**
   * Show a loading toast
   * Returns a function to update or dismiss the toast
   */
  loading: (message: string) => {
    return sonnerToast.loading(message)
  },

  /**
   * Show a promise toast
   * Automatically shows loading, success, and error states
   */
  promise: <T>(
    promise: Promise<T>,
    options: {
      loading: string
      success: string | ((data: T) => string)
      error: string | ((error: unknown) => string)
    }
  ) => {
    return sonnerToast.promise(promise, options)
  },

  /**
   * Dismiss a specific toast or all toasts
   */
  dismiss: (toastId?: string | number) => {
    sonnerToast.dismiss(toastId)
  },
}

export default toast
